export default __webpack_public_path__ + "static/media/kr3.56b228b8.png";